<template>
    <div class="pathways" v-if="canView('pathways')">
        <div class="row px-2 mb-5">
            <nav id="pathway-tab-nav" class="navbar navbar-expand primary-tab-bar">
                <div class="container-fluid">
                    <div class="collapse navbar-collapse">
                    <ul class="navbar-nav mb-md-0">
                        <li class="nav-item" v-for="(tab_name, index) in pathway_tabs">
                            <a class="nav-link d-flex flex-nowrap primary-tab" :class="{'primary-tab-active': pathway_tab_active == tab_name}"
                            href="#" role="button" aria-expanded="false" @click.prevent="setActiveTab(tab_name)">
                                <span>{{ tab_name }}</span>
                                <!--<p>Optional description</p>-->
                            </a>
                        </li>
                    </ul>
                    </div>
                </div>
            </nav>

            <div class="pathways-manage p-0">
                <div v-if="pathway_tab_active == 'Push Audiences' && canEdit('pathways')">
                    <pathways-push-segment :connection_datasets="connection_datasets" :client="client" :segments="local_segments"
                    :datasets= "datasets" :datablends= "datablends" :census_connections="census_connections"
                    :segment_selected_passed="segment_selected_passed" :pathway_selected_passed="pathway_selected_passed"></pathways-push-segment>
                </div>
                <div v-if="pathway_tab_active == 'Manage Pathways'" class="px-1">
                    <pathways-manage-pathways :connection_datasets="connection_datasets" :client="client" :segments="segments" :datasets="datasets" 
                    :datablends="datablends" :census_connections="census_connections"></pathways-manage-pathways>
                </div>
                <div v-if="pathway_tab_active == 'Manage Audiences'" class="px-1">
                    <pathways-manage-segments :connection_datasets="connection_datasets" :client="client" :segments="segments" :datasets="datasets"  
                    :datablends="datablends" :census_connections="census_connections"></pathways-manage-segments>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import permissionsMixin from '../../mixins/permissions';

export default defineComponent({
    name: 'Pathways',
    mixins: [permissionsMixin],
    props: {
        datasets: {
            type: Array,
        },
        datablends: {
            type: Array,
        },
        connections: {
            type: Array,
        },
        client: {
            type: Object,
        },
        census_connections: {
            type: Array,
        },
        segments: {
            type: Array,
        },
        segment_selected_passed: {
            type: [Object, null],
            default: null
        },
        pathway_selected_passed: {
            type: [Object, null],
            default: null
        },
        tab_name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            pathway_tabs: ['Push Audiences', 'Manage Pathways', 'Manage Audiences'],
            pathway_tab_active: 'Push Audiences',
            local_datasets: [],
            local_datablends: [],
            local_census_connections: [],
            connection_datasets: [],
            local_segments: []
        }
    },
    beforeMount() {
        this.local_datasets = this.datasets;
        this.local_datablends = this.datablends;
        this.local_census_connections = this.census_connections;
        this.local_segments = this.segments;
        //loop through local_segments and remove an element if the dataset and datablend are null
        this.local_segments = this.local_segments.filter(segment => segment.data_source != null);
        this.local_segments.forEach(seg => {
            seg.pushed_pathways = [];
        })

        if (!this.canExport('pathways')) {
            this.pathway_tabs = ['Manage Pathways', 'Manage Audiences'];
            this.setActiveTab('Manage Pathways');
        } else {
            if (this.tab_name == 'push_audiences') {
                this.pathway_tab_active = 'Push Audiences';
            }
            if (this.tab_name == 'manage_pathways') {
                this.pathway_tab_active = 'Manage Pathways';
            }
            if (this.tab_name == 'manage_audiences') {
                this.pathway_tab_active = 'Manage Audiences';
            }
        }

        this.bindAndFilterOutSelfConnectingDatasets();
    },
    methods: {
        setActiveTab(tab_name) {
            this.pathway_tab_active = tab_name;

            var newURL = '/pathways/' + this.client.url + '/';
            if (tab_name == 'Push Audiences') {
                newURL += 'push_audiences';
            } else if (tab_name == 'Manage Pathways') {
                newURL += 'manage_pathways';
            } else {
                newURL += 'manage_audiences';
            }
            
            window.history.replaceState({}, {}, newURL);
        },
        bindAndFilterOutSelfConnectingDatasets() {
            var connection_dataset_list = []
            this.connections.forEach(connect => {
                var dataset_to_sync_list = []

                this.local_datablends.forEach(datablend => {
                    datablend.name = datablend.type.charAt(0).toUpperCase() + datablend.type.slice(1) + " Data Blend";
                    if(datablend.segments.length > 0) {
                        // Add modeled segments that are based on segments in this datablend
                        var datablend_with_modeled = {...datablend};
                        datablend_with_modeled.segments = [...datablend.segments];
                        
                        // Find modeled segments that should be included in this datablend
                        this.local_segments.forEach(segment => {
                            if (segment.type === 'modeled' && segment.source === 'segment') {
                                // Check if this modeled segment is based on a segment in this datablend
                                var baseSegment = datablend.segments.find(seg => seg.id === segment.data_source_id);
                                if (baseSegment && !datablend_with_modeled.segments.find(seg => seg.id === segment.id)) {
                                    datablend_with_modeled.segments.push(segment);
                                }
                            }
                        });
                        
                        // Sort segments by name
                        datablend_with_modeled.segments.sort((a, b) => a.name.localeCompare(b.name));
                        
                        dataset_to_sync_list.push(datablend_with_modeled)
                    }
                });

                this.local_datasets.forEach(dataset => {
                    if(dataset.connection_id != connect.id) {
                        if(dataset.segments.length > 0) {
                            // Add modeled segments that are based on segments in this dataset
                            var dataset_with_modeled = {...dataset};
                            dataset_with_modeled.segments = [...dataset.segments];
                            
                            // Find modeled segments that should be included in this dataset
                            this.local_segments.forEach(segment => {
                                if (segment.type === 'modeled' && segment.source === 'segment') {
                                    // Check if this modeled segment is based on a segment in this dataset
                                    var baseSegment = dataset.segments.find(seg => seg.id === segment.data_source_id);
                                    if (baseSegment && !dataset_with_modeled.segments.find(seg => seg.id === segment.id)) {
                                        dataset_with_modeled.segments.push(segment);
                                    }
                                }
                            });
                            
                            // Sort segments by name
                            dataset_with_modeled.segments.sort((a, b) => a.name.localeCompare(b.name));
                            
                            dataset_to_sync_list.push(dataset_with_modeled)
                        }
                    }
                });
                
                connect.datasets_to_sync = dataset_to_sync_list;
                connection_dataset_list.push(connect)
            });
            this.connection_datasets = connection_dataset_list;
            this.filtered_connection_datasets = connection_dataset_list;

            this.getSegmentDetails();
        },
        getSegmentDetails() {  // The one previously used a lot of object referencing and cause some bug, I had to destruct the arrays and object to fix the issue
            this.connection_datasets.forEach(conn => {
                var count_temp = 0
                var datasets_to_sync_temp = [];
                conn.datasets_to_sync.forEach(dataset => {
                    var dataset_temp = {...dataset};  // create new copy of dataset array
                    var segments_temp = [];
                    dataset.segments.forEach(segment => {
                        var seg_temp = {...segment}; // create new copy of segment object then update the new object
                        
                        // For modeled segments, we need to determine the correct source and data_source_id
                        // based on the segment they're modeled off of
                        if (seg_temp.type === 'modeled' && seg_temp.source === 'segment') {
                            // Find the base segment this modeled segment is based on
                            var baseSegment = this.local_segments.find(seg => seg.id === seg_temp.data_source_id);
                            if (baseSegment) {
                                // Use the base segment's source and data_source_id for sync purposes
                                seg_temp.source = baseSegment.source;
                                seg_temp.data_source_id = baseSegment.data_source_id;
                            }
                        }
                        
                        var lastSynced = this.lastSynced(conn.id, seg_temp);

                        seg_temp.last_synced = lastSynced.last_synced_at;
                        seg_temp.sync_errors = lastSynced.last_sync_status;

                            if(lastSynced.last_synced_at != null){
                                seg_temp.sync_active = true;
                                var index = this.local_segments.findIndex((seg)=> seg.id == seg_temp.id);
                                if(this.local_segments[index] != null && !this.local_segments[index].pushed_pathways.includes(conn.name)){
                                    this.local_segments[index].pushed_pathways.push({
                                        conn_id: conn.id,
                                        conn_name: conn.name,
                                        conn_icon: conn.integration.logo_url,
                                    });
                                }
                                count_temp++;
                            } else {
                                seg_temp.sync_active = false;
                            }
                            segments_temp.push(seg_temp);
                        })
                        dataset_temp.segments = [...segments_temp];
                        datasets_to_sync_temp.push(dataset_temp);
                    })
                    conn.datasets_to_sync = datasets_to_sync_temp;
                    conn.pushed_segment_count = count_temp;
                });
            },
            lastSynced(conn_id, segment) {
                let conn = this.getCensusConnection(conn_id, segment);
                var sync = this.getCensusSync(conn, segment);
                if(sync != null) {
                    //Find out if it is a file export
                    if(conn.destination_object == 'file') {
                        return {
                            last_synced_at: sync.updated_at,
                            last_sync_status: null
                        };
                    }
                    return {
                        last_synced_at: sync.last_synced_at,
                        last_sync_status: sync.last_sync_status
                    };
                }
                else {
                    return {
                        last_synced_at: null,
                        last_sync_status: null
                    };
                }
            },
            getCensusConnection(conn_id, segment) {
                for(var i = 0; i < this.local_census_connections.length; i++) {
                    if(this.local_census_connections[i].connection_id == conn_id && segment.source == this.local_census_connections[i].source
                        && segment.data_source_id == this.local_census_connections[i].data_source_id) {
                            return this.local_census_connections[i];
                    }
                }
                return null;
            },
            getCensusSync(conn, segment) {
                if(conn == null) return null;

            for(var j = 0; j < conn.syncs.length; j++) {
                if(conn.syncs[j].segment_id == segment.id)
                    return conn.syncs[j];
            }
            return null;
        }
    }
})
</script>
